import React from 'react';

import { IonPage } from '@ionic/react';
import { RouterProps } from 'react-router';

import styles from './Login.module.css';

import logo from './images/logo-vert.svg';
import LoginForm from '../components/LoginForm';

const Login = ({ history }: RouterProps) => {
  const onNavigateToAccount = () => {
    history.push('/home');
  };
  return (
    <IonPage>
      <div className={styles.container}>
        <div className={styles.logoBanner}>
          <img
            className={styles.logo}
            src={logo}
            alt="Seven Mocks Taproom - Friar's Union"
          />
          <span className={styles.colorSpan}></span>
        </div>
        <LoginForm navigateToAccount={onNavigateToAccount} />
      </div>
    </IonPage>
  );
};

export default Login;
